import axios from "axios";
import {
  LoginInterface,
  LoginResponseInterface,
} from "@/resources/interfaces/userInterfaces";
import moment from "moment";

export class AuthService {
  async logIn(data: LoginInterface): Promise<any> {
    return await axios.post(`authentication`, data);
  }
  async loginGuestUser(token, data): Promise<any> {
    return await axios.post(
      `api/users/invitation/invite_guest_by_space_token/${token}`,
      data
    );
  }
  async resetPassword(token: string, data): Promise<any> {
    return await axios.post(`api/users/reset_password/${token}`, data);
  }
  async requestPassword(data): Promise<any> {
    return await axios.post(`api/users/request_password`, data);
  }
  async sendActivationUserEmail(token, data): Promise<void> {
    return await axios.post(
      `api/users/invitation/invite_user_by_space_token/${token}`,
      data
    );
  }
  async requestPin(data): Promise<any> {
    return await axios.post(`/pin/request`, data);
  }
  async authenticationPin(data): Promise<any> {
    return await axios.post(`/pin/authentication`, data);
  }
  async autoLoginMicrosoft(data): Promise<any> {
    return await axios.post(`/teams/authentication`, data);
  }
  //https://preproduccio.autenticaciogicar5.extranet.gencat.cat/realms/gicar-ad/protocol/openid-connect/auth
  async loginGicar(data: any) {
    console.log("TTT loginGicar Service ", data);
    const clientId = "nubi-tec-internet";
    const clientSecred = "h3jg0KsmaIdvTg5L047l7weiHuS5X8li";
    const scope =  encodeURIComponent("openid email profile");
    const redirectUri = encodeURIComponent("http://localhost:8080/auth/gicar/callback"); //https://dev.nubi.city/auth/gicar/callback //https://ctti.nubi.city/auth/gicar/callback
    const responseType = "code";
    let state = this.generateRandomString(16);
    let nonce = this.generateRandomString(16);
    localStorage.setItem("oauthState", state);
    localStorage.setItem("oauthNonce", nonce);
    const authUrl = `https://preproduccio.autenticaciogicar5.extranet.gencat.cat/realms/gicar-ad/protocol/openid-connect/auth?client_id=${clientId}&response_type=${responseType}&scope=${scope}&redirect_uri=${redirectUri}&state=${state}&nonce=${nonce}`;
    window.location.href = authUrl;
    //return await fetch(`https://preproduccio.autenticaciogicar5.extranet.gencat.cat/realms/gicar-ad/protocol/openid-connect/auth?client_id=${clientId}&response_type=${responseType}&scope=${scope}&redirect_uri=${redirectUri}&state=${state}&nonce=${nonce}`, { method: "GET"});
  }
  logOut(): void {
    localStorage.clear();
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    window.location.reload();
  }
  async refreshToken(isForce = false): Promise<any> {
    const refreshToken = localStorage.getItem("refresh_token");
    const tokenExp = parseInt(localStorage.getItem("exp"));
    if (
      isForce ||
      moment(tokenExp * 1000)
        .utc()
        .isBefore(moment().utc()) ||
      !tokenExp
    ) {
      console.log(
        "REFRESH",
        moment(tokenExp * 1000).format("HH:mm"),
        moment(tokenExp * 1000).isBefore(moment()),
        moment().format("HH:mm")
      );
      const data = {
        refresh_token: refreshToken,
      };
      return await axios
        .post("/token/refresh", data)
        .then((response) => {
          this.decodeJwt(response.data);
        })
        .catch((error) => {
          console.log("refreshToken ", error);
          localStorage.removeItem("token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("roles");
          localStorage.removeItem("user");
          localStorage.removeItem("gapiA");
          localStorage.removeItem("gapiR");
          localStorage.removeItem("hapiA");
        });
    }
  }
  decodeJwt(data: LoginResponseInterface): void {
    const { refresh_token, token } = data;
    const jwtObject = JSON.parse(atob(token.split(".")[1]));
    const { id, roles, exp, isHawkingsSinglePlayer } = jwtObject;
    localStorage.setItem("token", token || "");
    localStorage.setItem("refresh_token", refresh_token);
    localStorage.setItem("user", id);
    localStorage.setItem("roles", roles);
    localStorage.setItem("exp", exp);
    localStorage.setItem("single", isHawkingsSinglePlayer);
    const guestInvitationToken = localStorage.getItem("guestInvitationToken");
    const guestInvitationRefreshToken = localStorage.getItem(
      "guestInvitationRefreshToken"
    );
    if (guestInvitationToken && guestInvitationRefreshToken) {
      localStorage.setItem("guestInvitationToken", token || "");
      localStorage.setItem("guestInvitationRefreshToken", refresh_token);
    }
  }
  generateRandomString(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}
}

